export const delete_SplitButton = "myd";
export const flagUnflag_SplitButton = "nyd";
export const junk_SplitButton = "oyd";
export const newMessage_SplitButton = "pyd";
export const respond_SplitButton = "qyd";
export default {delete_SplitButton,flagUnflag_SplitButton,junk_SplitButton,newMessage_SplitButton,respond_SplitButton};